import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/ui/icons/Icon';
import iconsList from '../../../components/ui/icons/iconsList';
import logo from '../../../assets/FinalStage/finalPage/realisticIsraelLogo.svg';
import logoContest from '../../../assets/FinalStage/finalPage/logoContest.png';
import skillzLogo from "../../../assets/header/skillzLogo.png";
import classes from './FinalHeaderPage.module.css';

const FinalHeaderPage = ({ onBack }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const { currentContestId, activeContests } = useSelector(state => state.contest);
    const contest = activeContests.find(contest => String(contest.id) === String(currentContestId));
    const logoUrl = contest?.contestLogo?.replace('{lang}', lang || 'he');

    return (
        <div className={classes.BannerTopComponent} >
            <div className={classes.bannerTop}>
                <div className={classes.bannerTopContent}>
                    <Icon name={iconsList.backArrow} onClick={onBack} className={classes.backIcon} />
                    <div className={classes.logoContestContainer}>
                        <img src={logoUrl} className={classes.logoContest} />
                        <p className={classes.title}>{texts?.finalPageTitle}</p>
                    </div>
                </div>
                <div className={classes.skillzBlock}>
                    <div className={classes.skillzBlockItems}>
                        <img src={skillzLogo} alt="SkillZ" className={classes.skillzLogo} />
                        <div className={classes.stemText}>
                            <div>{texts?.champions}</div>
                            <div>{texts?.year}</div>
                        </div>
                    </div>
                    <img src={logo} alt="STEM" className={classes.stemLogo} />
                </div>
            </div>
        </div>
    );
};

export default FinalHeaderPage;
